import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../../api/analyticsApi';
import { analyticsKeys } from './analyticsKeys';

export const useLearningSummary = (startDate: string, endDate: string) =>
    useQuery({
        queryKey: analyticsKeys.learningSummary(startDate, endDate),
        queryFn: () => analyticsApi.getLearningSummary(startDate, endDate),
        staleTime: 5 * 60 * 1000,
    });

export const useWordbookDetail = (startDate: string, endDate: string, enabled: boolean) =>
    useQuery({
        queryKey: analyticsKeys.wordbookDetail(startDate, endDate),
        queryFn: () => analyticsApi.getWordbookDetail(startDate, endDate),
        staleTime: 5 * 60 * 1000,
        enabled,
    });
